
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  watch,
} from 'vue';

interface IList {
  text: string;
}
export default defineComponent({
  props: {
    listFilter: {
      type: Array as PropType<IList[]>,
      default: () => [],
    },

    selectAll: {
      type: Array,
      default: () => [],
    },

    cancelProp: {
      type: Boolean,
      default: false,
    },

    labelFilter: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    const propsRef = ref(props);
    const selectedValue = ref<any>([]);

    const cancelProp = computed(() => {
      return propsRef.value.cancelProp;
    });

    onMounted(() => ((selectedValue.value as any) = propsRef.value.selectAll));

    const eventStop = (e) => {
      e.stopPropagation();
    };

    const isCheck = ref(true);

    onMounted(() =>
      propsRef.value.listFilter.length === selectedValue.value.length
        ? (isCheck.value = true)
        : (isCheck.value = false)
    );

    const changeAllUnits = () => {
      if (isCheck.value) {
        emit('all-units', isCheck.value);
        return ((selectedValue.value as any) = propsRef.value.selectAll);
      }
      emit('clear-filter');
      selectedValue.value = [];
    };

    const changeUnit = () => {
      emit('value-selected', selectedValue.value);
      if (propsRef.value.listFilter.length === selectedValue.value.length)
        isCheck.value = true;
      else isCheck.value = false;
    };

    const selectAll = computed(() => propsRef.value.selectAll);
    watch(
      selectAll,
      () => {
        selectedValue.value = propsRef.value.selectAll;
      },
      { deep: true }
    );

    propsRef.value.selectAll,
      watch(
        cancelProp,
        () => {
          (selectedValue.value as any) = propsRef.value.selectAll;
        },
        { deep: true }
      );

    return {
      selectedValue,
      emit,
      eventStop,
      isCheck,
      changeAllUnits,
      changeUnit,
    };
  },
});
